// =================================================================
// ToggleCM.js - Toggle CM Fonctionnel Oracle TRYA
// Design exact du mockup avec fonctionnalité complète
// =================================================================

import React from 'react';

const ToggleCM = ({ cmActive, onToggle, className = '' }) => {
  return (
    <div className={`cm-toggle-container ${className}`}>
      <style>{`
        .cm-toggle-container {
          display: flex;
          align-items: center;
          gap: 12px;
          background: #f9fafb;
          padding: 8px 16px;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
        }
        
        .cm-switch {
          position: relative;
          width: 48px;
          height: 24px;
          background: #d1d5db;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .cm-switch.active {
          background: linear-gradient(135deg, #1D4ED8 0%, #1e40af 100%);
          box-shadow: 0 2px 8px rgba(29,78,216,0.3), 0 0 6px rgba(29,78,216,0.15);
        }
        
        .cm-switch-handle {
          position: absolute;
          top: 2px;
          left: 2px;
          width: 20px;
          height: 20px;
          background: white;
          border-radius: 50%;
          transition: all 0.3s ease;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        
        .cm-switch.active .cm-switch-handle {
          transform: translateX(24px);
        }
        
        .cm-label {
          font-size: 13px;
          font-weight: 600;
          color: #374151;
          transition: color 0.3s ease;
        }
        
        .cm-label.active {
          color: #1D4ED8;
        }
        
        .cm-status-badge {
          background: #fef3c7;
          color: #92400e;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.5px;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        .cm-status-badge.active {
          opacity: 1;
          background: #bfdbfe;
          color: #1D4ED8;
        }
      `}</style>
      
      {/* Toggle Switch */}
      <div 
        className={`cm-switch ${cmActive ? 'active' : ''}`}
        onClick={onToggle}
      >
        <div className="cm-switch-handle"></div>
      </div>
      
      {/* Label */}
      <span className={`cm-label ${cmActive ? 'active' : ''}`}>
        {cmActive ? 'EXPERTISE' : 'STANDARD'}
      </span>
      
      {/* Badge statut */}
      <span className={`cm-status-badge ${cmActive ? 'active' : ''}`}>
        {cmActive ? 'ACTIF' : 'INACTIF'}
      </span>
    </div>
  );
};

export default ToggleCM;
